import { c as create_ssr_component, f as createEventDispatcher, o as onDestroy, b as add_attribute, a as subscribe, v as validate_component, e as escape } from "./ssr.js";
import { p as page } from "./stores.js";
import { c as classNames } from "./util.js";
import "./client.js";
import { N as NotEditable } from "./NotEditable.js";
import { P as PrimaryButton } from "./PrimaryButton.js";
import { I as Input } from "./Input.js";
import { S as SecondaryButton } from "./SecondaryButton.js";
import { p as previousPage } from "./stores2.js";
const Modal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { position = "bottom" } = $$props;
  let modalEl;
  createEventDispatcher();
  let surface;
  onDestroy(() => {
  });
  if ($$props.position === void 0 && $$bindings.position && position !== void 0)
    $$bindings.position(position);
  return `<div class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true"${add_attribute("this", modalEl, 0)}><div class="fixed inset-0 bg-black bg-opacity-80"></div>  <div class="fixed inset-0 z-50 overflow-y-auto"><div${add_attribute("class", classNames("flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0", position === "bottom" ? "items-end" : "items-start"), 0)}${add_attribute("this", surface, 0)}><div class="relative rounded-lg bg-white text-left shadow-xl sm:my-8 w-full sm:max-w-lg">${slots.default ? slots.default({}) : ``}</div></div></div></div>`;
});
const WebsiteNav = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let data;
  let currentUser;
  let latestBio;
  let $$unsubscribe_previousPage;
  let $page, $$unsubscribe_page;
  $$unsubscribe_previousPage = subscribe(previousPage, (value) => value);
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { editable = false } = $$props;
  let { bio = void 0 } = $$props;
  let { showMenu = false } = $$props;
  let { backButton = false } = $$props;
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  if ($$props.bio === void 0 && $$bindings.bio && bio !== void 0)
    $$bindings.bio(bio);
  if ($$props.showMenu === void 0 && $$bindings.showMenu && showMenu !== void 0)
    $$bindings.showMenu(showMenu);
  if ($$props.backButton === void 0 && $$bindings.backButton && backButton !== void 0)
    $$bindings.backButton(backButton);
  data = $page.data;
  currentUser = data.currentUser;
  latestBio = bio || data.bio;
  $$unsubscribe_previousPage();
  $$unsubscribe_page();
  return `<div${add_attribute("class", classNames("backdrop-blur-sm z-10 text-sm lg:text-lg", !editable ? "sticky top-0" : "", "bg-white bg-opacity-95"), 0)}><div class="max-w-screen-md mx-auto py-4 px-6">${validate_component(NotEditable, "NotEditable").$$render($$result, { editable }, {}, {
    default: () => {
      return `<div class="flex items-center relative space-x-4"><a href="/" class="text-lg font-bold uppercase">${escape(backButton ? "← " : "")} ${escape(latestBio.name)}</a> <div class="flex-1"></div> ${currentUser ? `${validate_component(PrimaryButton, "PrimaryButton").$$render($$result, { size: "sm", href: "/posts/new" }, {}, {
        default: () => {
          return `New post`;
        }
      })}` : ``} <button class="w-[26px] h-[26px] border border-black rounded-full"${add_attribute("title", "Open Menu", 0)} data-svelte-h="svelte-1oiqhva"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"></path></svg></button></div>`;
    }
  })}</div></div> ${showMenu && !editable ? `${validate_component(Modal, "Modal").$$render($$result, {}, {}, {
    default: () => {
      return `<div class="p-8 flex flex-col space-y-4 relative"><button class="absolute right-6 sm:-right-4 -top-4 bg-black text-white rounded-full" data-svelte-h="svelte-3kxx8k"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg></button> ${currentUser ? `${slots.default ? slots.default({}) : ``} <div class="space-y-4 flex flex-col pt-8">${validate_component(PrimaryButton, "PrimaryButton").$$render($$result, { size: "sm", href: "/posts/new" }, {}, {
        default: () => {
          return `New post`;
        }
      })}</div> <div class="space-y-4 flex flex-col">${$page.url?.pathname !== "/friends" ? `${validate_component(SecondaryButton, "SecondaryButton").$$render($$result, { size: "sm", href: "/friends" }, {}, {
        default: () => {
          return `Manage friends`;
        }
      })}` : ``}</div>` : ``} ${currentUser ? `<div class="pt-8 flex"><div>Signed in as ${escape(currentUser.name)}</div> <div class="flex-1"></div> <div><a data-sveltekit-preload-data="off" class="underline" href="/logout" data-svelte-h="svelte-1fg00z1">Sign out</a></div></div>` : `<div class=""><form method="POST" action="/login" class="flex flex-col space-y-8"><div class="flex flex-col"><label for="password" class="font-semibold mb-6 text-3xl" data-svelte-h="svelte-1q2zruy">Sign in</label> ${validate_component(Input, "Input").$$render(
        $$result,
        {
          type: "password",
          name: "password",
          id: "password",
          placeholder: "Enter your password"
        },
        {},
        {}
      )}</div> ${validate_component(PrimaryButton, "PrimaryButton").$$render($$result, { type: "submit" }, {}, {
        default: () => {
          return `Sign in`;
        }
      })} <div class="pt-8 text-sm sm:text-base" data-svelte-h="svelte-9nzcf6">Only the owner can sign in. But you can run <a class="underline" href="https://www.postowl.com">PostOwl</a> yourself.</div></form></div>`}</div>`;
    }
  })}` : ``} `;
});
export {
  WebsiteNav as W
};
